import { render, staticRenderFns } from "./matterdetail.vue?vue&type=template&id=657e779f&scoped=true&"
import script from "./matterdetail.vue?vue&type=script&lang=js&"
export * from "./matterdetail.vue?vue&type=script&lang=js&"
import style0 from "./matterdetail.vue?vue&type=style&index=0&id=657e779f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e779f",
  null
  
)

export default component.exports